module.exports = __webpack_public_path__ + "img/bus-d.9274f411.png";